import qs from 'qs'
import fetch from '../utils/Fetch'
import config from '@/config/Config.vue'

//用户编辑
export function userEdit(data) {
    return fetch({
        url: config.WEB_USEREDIT_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}
//用户个人信息
export function userInfo(data) {
    return fetch({
        url: config.WEB_USERINFO_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}
//用户车辆认证
export function authUserVehicleLicense(data) {
    return fetch({
        url: config.WEB_USER_AUTH_VEHICLE_LICENSE_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}
//查询用户车辆认证审核
export function queryVehicleLicenseAuth(data) {
    return fetch({
        url: config.WEB_QUERY_VEHICLE_LICENSE_AUTH_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}
//解绑用户车辆认证审核
export function unbindVehicleLicense(data) {
    return fetch({
        url: config.WEB_UNBIND_VEHICLE_LICENSE_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}
